import { SxProps, Theme } from '@mui/material'
import { colors } from '../theme'
import { setOpacity } from '../../utils/setOpacity'

const getSoftColor = (color: string | undefined, alpha: number) => {
  if (!color) {
    return `rgba(105, 141, 172, ${alpha})`
  }

  if (color.startsWith('#')) {
    return setOpacity(color, alpha)
  }

  const rgbMatch = color.match(/^rgba?\(([^)]+)\)$/)
  if (rgbMatch) {
    const [r = '105', g = '141', b = '172'] = rgbMatch[1].split(',').map((part) => part.trim())
    return `rgba(${r}, ${g}, ${b}, ${alpha})`
  }

  return `rgba(105, 141, 172, ${alpha})`
}

interface SoftChipOptions {
  height?: number
  fontSize?: number
  labelWeight?: number
  solid?: boolean
  maxWidth?: string | number
  emphasis?: boolean
}

export const getSoftChipSx = (
  baseColor?: string,
  {
    height = 24,
    fontSize = 11.5,
    labelWeight = 500,
    solid = false,
    maxWidth = '100%',
    emphasis = false,
  }: SoftChipOptions = {}
): SxProps<Theme> => ({
  height: emphasis ? Math.max(height, 28) : height,
  maxWidth,
  borderRadius: '999px',
  backgroundColor: solid
    ? baseColor || colors.blueSky
    : getSoftColor(baseColor || colors.blueSky, emphasis ? 0.28 : 0.16),
  color: solid ? '#fff' : colors.cello,
  border: solid ? 'none' : `1px solid ${getSoftColor(baseColor || colors.blueSky, emphasis ? 0.5 : 0.26)}`,
  boxShadow: 'none',
  '& .MuiChip-label': {
    px: emphasis ? 1.35 : 1.1,
    fontSize: emphasis ? Math.max(fontSize, 12.5) : fontSize,
    fontWeight: emphasis ? Math.max(labelWeight, 600) : labelWeight,
    lineHeight: `${(emphasis ? Math.max(height, 28) : height) - 4}px`,
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
})
